



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import HandleGuestForm from "./HandleGuestForm.vue";
import HandleLoggedinPlayer from "./HandleLoggedinPlayer.vue";
import { JinroRoomDocument } from "../../../services/datatypes";

@Component({
  components: {
    HandleGuestForm,
    HandleLoggedinPlayer
  }
})
export default class Owner extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;

  get isRedirectAfterAdded(): boolean {
    return false;
  }
}
